import { render, staticRenderFns } from "./ItemDescription.vue?vue&type=template&id=4c24c81b&scoped=true&"
import script from "./ItemDescription.vue?vue&type=script&lang=js&"
export * from "./ItemDescription.vue?vue&type=script&lang=js&"
import style0 from "./ItemDescription.vue?vue&type=style&index=0&id=4c24c81b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24c81b",
  null
  
)

export default component.exports